<template>
  <!-- timeline -->
  <div class="timeline-wrap">
    <ol class="timeline">

      <!-- Entry #1 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'drafting-compass']" class="services__icon" />Print & Branding
        </time>
        <ul class="timeline__list">
          <li>Your logo, business cards and public stationeries are all a reflection of you and your company</li>
        </ul>
      </li>

      <!-- Entry #2 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'bezier-curve']" class="services__icon" />UI/UX Design
        </time>
        <ul class="timeline__list">
          <li>Strong preference for easy to use, intuitive UX/UI</li>
        </ul>
      </li>

      <!-- Entry #3 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'code']" class="services__icon" />Web Application Development
        </time>
        <ul class="timeline__list">
          <li>Fast, responsive and engaging apps that bring your ideas to life</li>
        </ul>
      </li>

      <!-- Entry #4 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'mobile-alt']" class="services__icon" />Mobile Application Development
        </time>
        <ul class="timeline__list">
          <li>Cross-platform apps built with efficiency and speed for Android and iOS at once</li>
        </ul>
      </li>

      <!-- Entry #5 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'cogs']" class="services__icon" />API Integration & Development
        </time>
        <ul class="timeline__list">
          <li>REST API development with Node.js and Koa.js</li>
        </ul>
      </li>

      <!-- Entry #6 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'cloud']" class="services__icon" />Cloud Integration
        </time>
        <ul class="timeline__list">
          <li>Deployment of apps and databases to leading cloud platforms such as Heroku, Google Firebase and Amazon AWS</li>
        </ul>
      </li>

      <!-- Entry #7 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'database']" class="services__icon" />Database Design
        </time>
        <ul class="timeline__list">
          <li>Database architectures in MongoDB, Sequelize, MySQL or PostgreSQL, always aiming for performance, scale and stability</li>
        </ul>
      </li>

      <!-- Entry #8 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'search']" class="services__icon" />SEO & Optimization
        </time>
        <ul class="timeline__list">
          <li>Search Engine Optimization and page performance is often the key to success for web-based products and companies</li>
        </ul>
      </li>

      <!-- Entry #9 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'hand-holding-usd']" class="services__icon" />Payment Gateway Integration
        </time>
        <ul class="timeline__list">
          <li>Integration with the most popular Payment Gateways such as Stripe and Paypal</li>
        </ul>
      </li>
      
      <!-- Entry #10 -->
      <li class="timeline__entry">
        <time>
          <font-awesome-icon :icon="['fas', 'chart-pie']" class="services__icon" />Analytics
        </time>
        <ul class="timeline__list">
          <li>Get insights into who is browsing your site so that you can make smarter business desicions</li>
        </ul>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "Timeline"
};
</script>
